<template>
  <div>
    <div id='map' style="height: 650px; width: 100%;">

  </div>

    <div v-for="job in jobs" :key="job.id" style="background-color: #e9ecef;" class="mt-1 pb-2 pt-1 px-2" >
      <p style="font-size: 22px; font-weight: 600; color: #E80000; margin-bottom: 0.25rem;" class="mt-4">{{ job.title }}</p>
      <p style="margin-bottom: 0rem;">{{ job.company }}</p>
      <p style="font-size: 18px; font-weight: 400; color: #999;">{{ job.city }}, {{ job.provincestate }}, {{ job.country_selector }} </p>
      <!-- <p>({{ job.job_latitude }}, {{ job.job_longitude }})</p> -->
      <!-- <hr> -->
    </div>

    <!-- {{ jobListing }} -->
    <!-- {{ jobListings }} -->
  </div>
</template>

<script>
  import MarkerClusterer from '@google/markerclusterer';

  import gmapsInit from '../utils/gmaps';
  import axios from 'axios'

  export default {
    data () {
      return {
        jobs: [],
        jobListings: [],
        // jobListing: new google.maps.LatLng(41.5050175, -73.0682531),
      }
    },
    created () {
      this.getJobs();
    },
    // https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/
    async mounted() {

      try { // https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/
        const google = await gmapsInit();
        const map = new google.maps.Map(document.getElementById('map'), {
          // zoom: 12,
          zoom: 3,
          // center: {lat: 52.520, lng: 13.410}
          center: {lat: 15.0, lng: 0.0}
        });

        // https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/
        const markerClickHandler = (marker) => {
          map.setZoom(11);
          map.setCenter(marker.getPosition());
        };

        // Markers:
        // https://developers.google.com/maps/documentation/javascript/custom-markers
        // https://developers-dot-devsite-v2-prod.appspot.com/maps/documentation/javascript/examples/icon-complex
        // https://developers-dot-devsite-v2-prod.appspot.com/maps/documentation/javascript/examples/marker-animations-iteration
        const jobListings = [
          {
            position: new google.maps.LatLng(13.524834, 2.109823),
            icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/STAR-icon.png',
          },
          {
            position: new google.maps.LatLng(49.884017, -97.168579),
            icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/redcross-icon.png',
          },
          {
            position: new google.maps.LatLng(45.421106, -75.690308),
            icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/redcross-icon.png',
          },
          // {
          //   position: new google.maps.LatLng(45.421106, -75.690308),
          //   icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/redcross-icon.png',
          // },
          {
            position: new google.maps.LatLng(41.5050175, -73.0682531),
            icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/save-the-children-icon2.png',
          }
        ]

        // var marker1 = new google.maps.Marker({
        //   // position: features[i].position,
        //   position: new google.maps.LatLng(13.524834, 2.109823),
        //   // icon: icons[features[i].type].icon,
        //   icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/STAR-icon.png',
        //   map: map
        // });
        // marker1.addListener(`click`, () => markerClickHandler(marker1));

        // var marker2 = new google.maps.Marker({
        //   // position: features[i].position,
        //   position: new google.maps.LatLng(49.884017, -97.168579),
        //   // icon: icons[features[i].type].icon,
        //   // icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/save-the-children-icon2.png',
        //   map: map
        // });

        // var marker3 = new google.maps.Marker({
        //   // position: features[i].position,
        //   position: new google.maps.LatLng(45.421106, -75.690308),
        //   // icon: icons[features[i].type].icon,
        //   // icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/save-the-children-icon2.png',
        //   map: map
        // });

        // var marker4 = new google.maps.Marker({
        //   // position: features[i].position,
        //   position: new google.maps.LatLng(45.421106, -75.690308),
        //   // icon: icons[features[i].type].icon,
        //   // icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/save-the-children-icon2.png',
        //   map: map
        // });

        // var marker5 = new google.maps.Marker({
        //   // position: features[i].position,
        //   position: new google.maps.LatLng(41.5050175, -73.0682531),
        //   // icon: icons[features[i].type].icon,
        //   icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/save-the-children-icon2.png',
        //   map: map
        // });

        // https://developers.google.com/maps/documentation/javascript/infowindows, https://developers-dot-devsite-v2-prod.appspot.com/maps/documentation/javascript/examples/infowindow-simple, https://developers-dot-devsite-v2-prod.appspot.com/maps/documentation/javascript/examples/infowindow-simple-max
        var infowindow = new google.maps.InfoWindow({
          // content: contentString
          content: 'dude'
        });

        // https://developers.google.com/maps/documentation/javascript/custom-markers
        var markers = jobListings.map(function(jobListing) {
          // return new google.maps.Marker({
          var marker = new google.maps.Marker({
            position: jobListing.position,
            // label: labels[i % labels.length]
            icon: jobListing.icon,
            // title: 'test'
          });
          marker.addListener('click', function() {
            // infowindow.open(map, marker); // https://developers.google.com/maps/documentation/javascript/infowindows
            markerClickHandler(marker);
          });
          return marker;
        });

        new MarkerClusterer(map, markers, {
          imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
        });

      } catch (error) {
        console.error(error);
      }
    },
    methods: {
      // initMap() {
      //   map = new google.maps.Map(document.getElementById('map'), {
      //     zoom: 12,
      //     center: {lat: 52.520, lng: 13.410}
      //   });
      // },
      getJobs () {
        axios.get('/api/jobs/?agency=4')
          .then(res => {
            console.log(res)
            this.jobs = res.data

            // for (var job in res.data) {
            //   // console.log(res.data[job])
            //   const marker = {
            //     lat: res.data[job].job_latitude,
            //     lng: res.data[job].job_longitude
            //   };
            //   this.markers.push({ position: marker });
            // }

            // for (var job in res.data) {
            //   this.jobListings.push({res.data[job].title})
            //   // {res.data[job].job_latitude, res.data[job].job_longitude}
            // }

            // for (var job in this.jobs) {
            //   this.jobListings.push(
            //     { position: new google.maps.LatLng(this.jobs[job].job_latitude, this.jobs[job].job_longitude)}
            //   )
            // }

            // this.loadMap

          })
          .catch(error => console.log(error))
      },

      // loadMap() {
      //   try { // https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/
      //     const google = gmapsInit();
      //     const map = new google.maps.Map(document.getElementById('map'), {
      //       // zoom: 12,
      //       zoom: 3,
      //       // center: {lat: 52.520, lng: 13.410}
      //       center: {lat: 15.0, lng: 0.0}
      //     });

      //     // https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/
      //     const markerClickHandler = (marker) => {
      //       map.setZoom(11);
      //       map.setCenter(marker.getPosition());
      //     };

      //     // Markers:
      //     // https://developers.google.com/maps/documentation/javascript/custom-markers
      //     // https://developers-dot-devsite-v2-prod.appspot.com/maps/documentation/javascript/examples/icon-complex
      //     // https://developers-dot-devsite-v2-prod.appspot.com/maps/documentation/javascript/examples/marker-animations-iteration
      //     const jobListings = [
      //       {
      //         position: new google.maps.LatLng(13.524834, 2.109823),
      //         icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/STAR-icon.png',
      //       },
      //       {
      //         position: new google.maps.LatLng(49.884017, -97.168579),
      //         icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/redcross-icon.png',
      //       },
      //       {
      //         position: new google.maps.LatLng(45.421106, -75.690308),
      //         icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/redcross-icon.png',
      //       },
      //       // {
      //       //   position: new google.maps.LatLng(45.421106, -75.690308),
      //       //   icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/redcross-icon.png',
      //       // },
      //       {
      //         position: new google.maps.LatLng(41.5050175, -73.0682531),
      //         icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/save-the-children-icon2.png',
      //       }
      //     ]

      //     // https://developers.google.com/maps/documentation/javascript/infowindows, https://developers-dot-devsite-v2-prod.appspot.com/maps/documentation/javascript/examples/infowindow-simple, https://developers-dot-devsite-v2-prod.appspot.com/maps/documentation/javascript/examples/infowindow-simple-max
      //     var infowindow = new google.maps.InfoWindow({
      //       // content: contentString
      //       content: 'dude'
      //     });

      //     // https://developers.google.com/maps/documentation/javascript/custom-markers
      //     var markers = this.jobListings.map(function(jobListing) {
      //       // return new google.maps.Marker({
      //       var marker = new google.maps.Marker({
      //         position: jobListing.position,
      //         // label: labels[i % labels.length]
      //         // icon: jobListing.icon,
      //         // title: 'test'
      //       });
      //       marker.addListener('click', function() {
      //         // infowindow.open(map, marker); // https://developers.google.com/maps/documentation/javascript/infowindows
      //         markerClickHandler(marker);
      //       });
      //       return marker;
      //     });

      //     new MarkerClusterer(map, markers, {
      //       imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      //     });
      //   } catch (error) {
      //     console.error(error);
      //   }
      // },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/GoogleMapRaw.vue